<!-- Enable Screen Share -->
<div
  class="tw-flex tw-flex-row tw-gap-4 tw-items-start tw-pb-8 tw-border-solid tw-border-0 tw-border-b tw-border-gray-200"
>
  <mat-icon svgIcon="screen-share" class="large" aria-hidden="true"></mat-icon>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-4">
    <div>
      <div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
        <label for="enableScreenShareToggle" class="tw-mb-0 tw-font-bold"
          >Enable Screen Share</label
        >
        <ng-container [ngTemplateOutlet]="licenseRequired"></ng-container>
        @if (!isLicenseRequired) {
          <mat-slide-toggle
            [(ngModel)]="model.screenSharingEnabled"
            (change)="screenShareModeChange()"
            name="enableScreenShareToggle"
            id="enableScreenShareToggle"
          >
          </mat-slide-toggle>
        }
      </div>
      <div class="text-muted tw-mt-2 tw-text-[13px]">
        Allow you, and others to share their screen to this display.
      </div>
    </div>
  </div>
</div>

@if (model.screenSharingEnabled && model.isDisplayControlEnabled) {
  <div class="tw-pt-4">
    <div class="madero-style alert alert-info tw-border-0">
      <div class="tw-flex tw-items-start tw-gap-3">
        <mat-icon
          svgIcon="info"
          class="tw-text-blue-600"
          aria-hidden="true"
        ></mat-icon>
        <span class="tw-flex-1" style="color: initial">
          <strong>Display Control is turned on</strong>
          <p class="tw-mt-2 tw-mb-0">
            The display will turn off if there are no scheduled playlists, and
            the pairing code will not be shown. To allow the display to stay on,
            go to the <strong>Manage</strong> tab, and turn off
            <strong>Display Control</strong>.
          </p>
        </span>
      </div>
    </div>
  </div>
}

<!-- Permissions Section -->
@if (!isLicenseRequired && model.screenSharingEnabled) {
  <div class="tw-flex tw-flex-col tw-pt-8">
    <label class="tw-mb-0 tw-font-bold">Permissions</label>
    <div class="text-muted tw-mt-2 tw-text-[13px]">
      Allow anyone to share by entering the Pairing Code on this display.
    </div>
  </div>

  <!-- Show Session Code on Screen -->
  <div class="tw-flex tw-flex-row tw-gap-4 tw-pt-8 tw-items-start">
    <mat-icon
      svgIcon="session-code"
      class="large"
      aria-hidden="true"
    ></mat-icon>
    <div class="tw-w-full tw-flex tw-flex-col tw-gap-4">
      <div>
        <div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
          <label for="showSessionCodeToggle" class="tw-mb-0 tw-font-bold"
            >Show Session Code on Screen</label
          >
          <mat-slide-toggle
            [ngModel]="!model.settings.screenSharingCodeHidden"
            (ngModelChange)="screenShareCodeHiddenChange($event)"
            [disabled]="!model.screenSharingEnabled"
            name="showSessionCodeToggle"
            ngDefaultControl
            id="showSessionCodeToggle"
          >
          </mat-slide-toggle>
        </div>
        <div class="text-muted tw-mt-2 tw-text-[13px]">
          Displays the code on the corner of this display even while your
          content plays.
        </div>
      </div>
    </div>
  </div>

  <!-- Require Pin Confirmation -->
  <div class="tw-flex tw-flex-row tw-gap-4 tw-pt-8 tw-items-start">
    <mat-icon svgIcon="pin-code" class="large" aria-hidden="true"></mat-icon>
    <div class="tw-w-full tw-flex tw-flex-col tw-gap-4">
      <div>
        <div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
          <label for="requirePinConfirmationToggle" class="tw-mb-0 tw-font-bold"
            >Require Pin Confirmation</label
          >
          <mat-slide-toggle
            (change)="screenSharePinRequiredChange($event.checked)"
            [(ngModel)]="model.settings.screenSharingPinRequired"
            [disabled]="!model.screenSharingEnabled"
            name="requirePinConfirmationToggle"
            ngDefaultControl
            id="requirePinConfirmationToggle"
          >
          </mat-slide-toggle>
        </div>
        <div class="text-muted tw-mt-2 tw-text-[13px]">
          The participant will be required to provide the pin set by you.
        </div>
      </div>
      @if (model.settings.screenSharingPinRequired) {
        <div>
          <div
            class="tw-flex tw-flex-col"
            [ngClass]="{
              'has-error':
                screenSharingPin.invalid &&
                (screenSharingPin.dirty || screenSharingPin.touched),
            }"
          >
            <label for="screenSharingPin" class="tw-mb-2 text-muted"
              >PIN Code</label
            >
            <input
              #screenSharingPin="ngModel"
              id="screenSharingPin"
              name="screenSharingPin"
              type="tel"
              class="form-control tw-max-w-[120px]"
              [required]="model.settings.screenSharingPinRequired"
              minlength="4"
              maxlength="4"
              pattern="[0-9]*"
              inputmode="numeric"
              autocomplete="off"
              aria-label="4-digit PIN Code"
              [(ngModel)]="model.settings.screenSharingPin"
            />
            @if (
              screenSharingPin.invalid &&
              (screenSharingPin.dirty || screenSharingPin.touched)
            ) {
              <p class="help-block text-danger tw-mb-0 tw-mt-1">
                Please enter a 4-digit numeric PIN code.
              </p>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Require Authentication -->
  <div class="tw-flex tw-flex-row tw-gap-4 tw-pt-8 tw-items-start">
    <mat-icon svgIcon="login-arrow" class="large" aria-hidden="true"></mat-icon>
    <div class="tw-w-full tw-flex tw-flex-col tw-gap-4">
      <div>
        <div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
          <label for="requireAuthenticationToggle" class="tw-mb-0 tw-font-bold"
            >Require Authentication</label
          >
          <mat-slide-toggle
            (change)="screenShareAuthenticationRequiredChange($event.checked)"
            [(ngModel)]="model.settings.screenSharingAuthenticationRequired"
            name="requireAuthenticationToggle"
            [disabled]="!model.screenSharingEnabled"
            ngDefaultControl
            id="requireAuthenticationToggle"
          >
          </mat-slide-toggle>
        </div>
        <div class="text-muted tw-mt-2 tw-text-[13px]">
          Participants have to log in to their Rise Vision account to share
          their screen.
        </div>
      </div>
    </div>
  </div>
}
